import { site } from "@/config/site";

const rows = [
  { label: "Legal company name", value: site.companyLegalName },
  { label: "CIN", value: site.cin },
  { label: "Incorporation date", value: site.incorporationDate },
  { label: "Registered office", value: site.registeredOffice },
];

export default function CorporateInfoCard() {
  return (
    <div
      data-testid="corporate-info-card"
      className="border border-fs-border bg-fs-card p-8 lg:p-10"
    >
      <div className="flex items-center gap-3">
        <span className="h-px w-8 bg-fs-gold/70" />
        <span className="text-xs uppercase tracking-[0.24em] text-fs-gold">
          Company incorporated in India
        </span>
      </div>
      <dl className="mt-8 space-y-6">
        {rows.map((r) => (
          <div
            key={r.label}
            className="grid gap-1 border-b border-fs-border pb-5 last:border-0 last:pb-0 sm:grid-cols-[180px_1fr] sm:gap-6"
          >
            <dt className="text-xs uppercase tracking-[0.16em] text-fs-muted/70">
              {r.label}
            </dt>
            <dd className="text-sm leading-relaxed text-fs-ink">{r.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
